export default {
  'pages.workbenchDashboard.title': '軟體工廠工作台',
  'pages.workbenchDashboard.subTitle':
    '彙總專案、資源與近期動態，快速了解整個軟體工廠的運行狀態。',
  'pages.workbenchDashboard.refresh': '重新整理',
  'pages.workbenchDashboard.loadingError': '工作台資料載入失敗，請稍後再試。',
  'pages.workbenchDashboard.partialStatsWarning':
    '部分專案程式碼統計未成功載入，目前總覽基於已返回的資料計算。',
  'pages.workbenchDashboard.empty': '暫無可展示資料',
  'pages.workbenchDashboard.lastUpdatedAt': '更新時間',
  'pages.workbenchDashboard.kpi.projects': '專案總數',
  'pages.workbenchDashboard.kpi.activeProjects': '近 7 天活躍專案',
  'pages.workbenchDashboard.kpi.applications': '應用總數',
  'pages.workbenchDashboard.kpi.workspaces': '工作區總數',
  'pages.workbenchDashboard.kpi.codebases': '程式碼倉庫總數',
  'pages.workbenchDashboard.kpi.activeAgents': '活躍 Agent',
  'pages.workbenchDashboard.kpi.totalCodeLines': '程式碼總行數',
  'pages.workbenchDashboard.kpi.generatedCodeLines': 'AI 生成程式碼行數',
  'pages.workbenchDashboard.kpi.newCodeLines': '今日新增程式碼行數',
  'pages.workbenchDashboard.sections.groupDistribution': '專案分組分布',
  'pages.workbenchDashboard.sections.resourceComposition': '資源結構概覽',
  'pages.workbenchDashboard.sections.activityTrend': '近 7 天平台動態趨勢',
  'pages.workbenchDashboard.sections.projectSnapshot': '專案運行快照',
  'pages.workbenchDashboard.sections.recentLogs': '最近平台動態',
  'pages.workbenchDashboard.sections.riskBoard': '結構性風險提醒',
  'pages.workbenchDashboard.sections.quickActions': '快捷入口',
  'pages.workbenchDashboard.charts.group.unGrouped': '未分組',
  'pages.workbenchDashboard.charts.resource.projects': '專案',
  'pages.workbenchDashboard.charts.resource.applications': '應用',
  'pages.workbenchDashboard.charts.resource.workspaces': '工作區',
  'pages.workbenchDashboard.charts.resource.codebases': '程式碼倉庫',
  'pages.workbenchDashboard.charts.resource.activeAgents': '活躍 Agent',
  'pages.workbenchDashboard.risk.noApplications': '未建立應用的專案',
  'pages.workbenchDashboard.risk.noActiveAgents': '未綁定活躍 Agent 的專案',
  'pages.workbenchDashboard.risk.noRecentActivity': '14 天內無動態的專案',
  'pages.workbenchDashboard.risk.ok': '目前沒有明顯的結構性風險。',
  'pages.workbenchDashboard.table.project': '專案',
  'pages.workbenchDashboard.table.group': '分組',
  'pages.workbenchDashboard.table.apps': '應用',
  'pages.workbenchDashboard.table.workspaces': '工作區',
  'pages.workbenchDashboard.table.agents': '活躍 Agent',
  'pages.workbenchDashboard.table.codeLines': '程式碼行數',
  'pages.workbenchDashboard.table.lastActivity': '最近動態',
  'pages.workbenchDashboard.quick.projects': '專案列表',
  'pages.workbenchDashboard.quick.devAgents': '開發 Agent 管理',
  'pages.workbenchDashboard.quick.estimationStandards': '工時評估標準',
  'pages.workbenchDashboard.log.empty': '最近暫無動態',
  'pages.workbenchDashboard.trend.totalOperations': '總操作數',
  'pages.workbenchDashboard.trend.failedOperations': '失敗操作數',
};
